import { useCallback } from 'react';
import { toFlagId, useFlagService } from '@atlassian/jira-flags';
import { ERROR_FLAG_ID } from './constants.tsx';
import messages from './messages.tsx';

export const useShowErrorFlag = () => {
	const { showFlag } = useFlagService();

	const showErrorFlag = useCallback(
		(errorMessageDescription?: string) =>
			showFlag({
				key: toFlagId(ERROR_FLAG_ID),
				testId: 'personal-settings-notifications-config-table.common.error-flag',
				type: 'error',
				title: messages.errorFlagTitleNonFinal,
				description: errorMessageDescription || messages.errorFlagDescriptionNonFinal,
				isAutoDismiss: true,
				messageId: 'personal-settings-error-flag.ui.show-flag.error',
				messageType: 'transactional',
			}),
		[showFlag],
	);

	return { showErrorFlag };
};
